<template>
  <div>
    <div class="row">
      <div v-if="isAward" class="col-12 mb-3">
        <div class="row">
          <div class="col-12">
            <label class="font-18  font-weight-bold m-3 ">
              <i class="fas fa-info-circle text-orange mr-1" />
              Información Adicional
            </label>
          </div>
          <div class="col-12 col-lg-3">
            <CustomInputDisplay
              class="font-weight-bold"
              label="Fecha de Vencimiento de Fondos:"
              label-class="text-gray font-weight-light"
              :value="$options.filters.date(model.fundExpirationDate)"
            />
          </div>
          <div class="col-12 col-lg-3">
            <CustomInputDisplay
              class="font-weight-bold"
              label="Fecha de Fondos Federales:"
              label-class="text-gray font-weight-light"
              :value="$options.filters.date(model.federalFundDate)"
            />
          </div>
          <div class="col-12 col-lg-3">
            <CustomInputDisplay
              class="font-weight-bold"
              label="Fecha de Fondos Estatales:"
              label-class="text-gray font-weight-light"
              :value="$options.filters.date(model.stateFundDate)"
            />
          </div>
          <div class="col-12 col-lg-3">
            <CustomInputDisplay
              class="font-weight-bold"
              label="Período Adicional Renovación:"
              label-class="text-gray font-weight-light"
              :value="model.additionalRenewalPeriod"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <label class="font-18  font-weight-bold m-3 ">
          <i class="fas fa-user text-orange mr-1" />
          Participantes
        </label>
      </div>
      <div class="col-12">
        <div
          v-for="(item, index) in model.signers"
          :key="index"
          class="mb-3 "
          :item="item"
        >
          <div class="custom-border rounded border-start bg-white p-3">
            <div class="row">
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Nombre:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ item?.name | empty }}
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Puesto:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ item?.chargeName | empty }}
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Área:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ item?.area | empty }}
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="color-secondary-6 font-14">
                  Tipo de Participación:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ item?.participantType?.name | empty }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLetterDetail } from '@/modules/proposalProcess/api.js';
import CustomInputDisplay from 'CustomInputDisplay';

export default {
  name: 'LetterDetails',
  components: {
    CustomInputDisplay,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isAward: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {},
    };
  },
  computed: {},
  async mounted() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      const { data } = await getLetterDetail(
        this.item?.id,
        this.item?.letterType?.id
      );
      this.model = data;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-border {
  border-left: 4px solid #aab7b1;
}
</style>
